import React from "react";
import PropTypes from "prop-types";
import noEntriesIcon from "assets/NoEntriesIcon.svg?url";

const NoEntries = ({ title, children }) => (
	<div className="ClassroomChat_noEntries">
		<img src={noEntriesIcon} alt="" />
		<p>
			<strong>{title}</strong>
		</p>
		{children}
	</div>
);

NoEntries.propTypes = {
	title: PropTypes.string,
	children: PropTypes.any,
};

export default NoEntries;
